export default __webpack_public_path__ + "static/media/as-giver.4205e1af.png";